module.exports = __webpack_public_path__ + "img/self_referral.816f1edd.svg";